import React, {FC} from "react";
import styled from "styled-components/macro";
import Box from "@mui/material/Box";
import {Button} from "@material-ui/core";
import {CloudUpload} from "@mui/icons-material";

const Empty = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 220px;
    width: 220px;
    border-radius: 6px;
    background: #677d8bb8;
    color: #233044;
    font-weight: 600;
`

type PropsType = {
  value: string | null
  onSetFieldValue: (field: string, value: any) => void
}

const LogoBlock: FC<PropsType> = ({value, onSetFieldValue}) => {
  return (
    <Box>
      {value ? (
        <img
          height={220}
          width={220}
          src={typeof value === 'string' ? value : URL.createObjectURL(value)}
          alt="logo"
        />
      ) : (
        <Empty>Empty</Empty>
      )}
      <Box mt={2}>
        <input
          accept="image/*"
          style={{ display: 'none' }}
          id="logo"
          multiple
          type="file"
          onChange={(e) => {
            const {files} = e.target
            if (files && files.length > 0) {
              onSetFieldValue('logo', files[0])
            }
          }}
        />
        <label htmlFor="logo">
          <Button
            variant="outlined"
            component="span"
            style={{minWidth: 200, display: 'flex', justifyContent: 'center', alignItems: 'center'}}
          >
            <Box mr={1}><CloudUpload/></Box>
             Upload new logo
          </Button>
        </label>
      </Box>
    </Box>
  )
}

export default LogoBlock